import React, {useState} from 'react';
import {isEmpty} from "../../../../helpers/helpers";
import Input from "../../../../atoms/input";
import ButtonBase from "../../../../atoms/button.base";
import StatusGit from "../../../../atoms/status_gif";
import {storeInvestment, storeInvestmentRequestHayaat} from "../../../../../models/applicant";
import Captcha from "../../../../molecules/auth/captcha";


const HayaatInvestmentForm = () => {

    const [form, setForm] = useState({
        name: '',
        contact_info: '',
        captcha: ''
    });
    const [formError, setFormError] = useState({
        name: '',
        contact_info: '',
    });
    const [submitLoading, setSubmitLoading] = useState(false);
    const [sentStatus, setSentStatus] = useState({status: '', text: ''});
    const [captcha, setCaptcha] = useState({token: '', error: ''});

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;

        setForm(state => ({
            ...state,
            [name]: value,
        }));
    };

    const submitRequestForm = () => {

        setSubmitLoading(true);

        const data = {
            mobile: form.contact_info,
            name: form.name,
            city_id: 207,
            district_id: [],
            deal_type: 'sale',
            price: 10000000,
            rent: null,
            mortgage: null,
            captcha_code: form.captcha,
            tag: 'hayaat',
        };

        storeInvestment(data).then(result => {
            setSentStatus({
                text: 'درخواست شما با موفقیت ثبت شد! <br/> به‌زودی همکاران ما با شما تماس می‌گیرند.',
                status: 'done',
            });

            setSubmitLoading(false);

            if (!isEmpty(window.dataLayer)) {
                window.dataLayer.push({
                    'event': 'landing-invest-request-submit',
                    'landing': 'hayaat',
                });
            }
        }).catch(error => {
            setSubmitLoading(false);

            if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
                const response = error.response.data;
                let errors = {name: '', contact_info: ''};

                if (!isEmpty(response) && !isEmpty(response.captcha_token)) {
                    setCaptcha({token: response.captcha_token, error: ''});
                }

                if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.mobile)) {
                    errors['contact_info'] = 'موبایل‌تون رو اشتباه وارد کردید.';
                }

                if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.full_name)) {
                    errors['name'] = ' نام و نام خانوادگی رو وارد کنید.';
                }

                setFormError(errors);
            } else {
                setSentStatus({
                    text: 'انگار خطایی رخ داد لطفا دوباره تلاش کنید.',
                    status: 'cancel',
                });
            }
        });
    };

    return (
        <div>
            {
                (isEmpty(sentStatus.status)) ?
                    <React.Fragment>

                        <Input
                            value={form.name}
                            name="name"
                            type="text"
                            onChange={handleChange}
                            className="w-100"
                            isInvalid={(!isEmpty(formError.name))}
                            invalidFeedback={formError.name}
                            label="نام و نام خانوادگی"
                        />

                        <Input
                            value={form.contact_info}
                            name="contact_info"
                            type="tel"
                            onChange={handleChange}
                            isInvalid={(!isEmpty(formError.contact_info))}
                            invalidFeedback={formError.contact_info}
                            className="w-100 mt-32"
                            label="تلفن تماس"
                        />

                        {
                            (!isEmpty(captcha.token)) ?
                                <Captcha
                                    handleChange={handleChange}
                                    token={captcha.token}
                                    error={captcha.error}
                                    captchaValue={form.captcha}
                                    className="text-right mt-24 mt-lg-32"
                                />
                                : ''
                        }

                        <ButtonBase
                            onClick={submitRequestForm}
                            className="mt-24 mt-lg-32"
                            loadingbar={submitLoading}
                            color="primary"
                            block>ثبت درخواست مشاوره</ButtonBase>
                    </React.Fragment>
                    :
                    <div className="text-center mb-32 mb-md-0">
                        <StatusGit text={sentStatus.text} status={sentStatus.status}/>
                    </div>
            }
        </div>
    );
};

export default React.memo(HayaatInvestmentForm);
